/**
 * @typedef {object} FeaturedHeadToHeadState
 * @property {object} data
 */

/**
 * @typedef {object} FeaturedHeadToHeadActions
 * @property {string} seasonId
 * @property {any} payload
 */
